module.exports = __webpack_public_path__ + "img/center_pc.4ffa6624.png";